const accountResourcesAPIPrefix = accountName => `/${accountName}/resources`;

export const accountResourcesApiFactory = ({ callGetApi }) => ({
    getSupplyTargeting: accountName => {
        return callGetApi(accountResourcesAPIPrefix(accountName) + '/supply-targeting');
    },
});
